<template>
   <BlockUI :blocked="blockedDocument" :fullScreen="true"></BlockUI>
   <div id="filters">
      <div id="card-filters" class="card">
         <div class="card-body px-0 py-3">
            <div class="card-title">
               <div class="row justify-content-start">
                  <div class="col-1">
                     <img class="card-icon" src="../assets/images/card-icon.svg" />
                  </div>
                  <div class="col-11">
                     <span class="card-header-1">Consulta de informes tal como fueron presentados al INE</span>
                     <br />
                     <span class="card-header-2">
                        Selecciona las opciones deseadas para realizar una búsqueda. Todos los campos con <span class="required-icon">*</span> son
                        obligatorios.
                     </span>
                  </div>
               </div>
            </div>
            <div class="row justify-content-start">
               <div class="col-12 mt-3">
                  <span class="card-form-title">Elige un Proceso o Ejercicio<span class="required-icon">*</span></span>
                  <img class="" src="../assets/images/help-icon.svg" @click="openProcessDialog" style="cursor: pointer; width:16px; height:16px; margin-left: 0.5rem; margin-bottom: 0.25rem;" />
               </div>
            </div>
            <div class="row justify-content-start my-3">
               <div class="col-4">
                  <div
                     class="w-auto card-form-process-button-normal"
                     @mouseenter="btnPrecampaniaMouseEnter"
                     @mouseleave="btnPrecampaniaMouseLeave"
                     @click="btnPrecampaniaMouseClick"
                  >
                     <img id="btn-filter-card-form-precampania" class="img-fluid" src="../assets/images/precampania_icono_inactivo.svg" />
                  </div>
               </div>
               <div class="col-4">
                  <div
                     class="w-auto card-form-process-button-noactive"
                     @mouseenter="btnCampaniaMouseLeave"
                     @mouseleave="btnCampaniaMouseLeave"
                     @click="btnCampaniaMouseClick"
                  >
                     <img id="btn-filter-card-form-campania" class="img-fluid" src="../assets/images/campania_icono_inactivo.svg" />
                  </div>
               </div>
               <div class="col-4">
                  <div
                     class="w-auto card-form-process-button-noactive"
                     @mouseenter="btnOrdinarioMouseLeave"
                     @mouseleave="btnOrdinarioMouseLeave"
                     @click="btnOrdinarioMouseClick"
                  >
                     <img id="btn-filter-card-form-ordinario" class="img-fluid" src="../assets/images/ordinario_icono_inactivo.svg" />
                  </div>
               </div>
            </div>
            <template v-if="idProceso == 1">
               <FilterCardOrdinario
                  :idProceso="idProceso"
                  :checkAjax="checkAjax"
                  :addAjax="addAjax"
                  :removeAjax="removeAjax"
                  :load500Error="load500Error"
                  :sincronizarOrdinario="sincronizarOrdinario"
               />
            </template>
            <template v-else>
               <FilterCardCampana
                  ref="filterCardCampana"
                  :idProceso="idProceso"
                  :checkAjax="checkAjax"
                  :addAjax="addAjax"
                  :removeAjax="removeAjax"
                  :load500Error="load500Error"
                  :sincronizar="sincronizar"
               />
            </template>

            <div class="row justify-content-end mt-4 pb-4">
               <div class="col-12 w-auto">
                  <div class="d-grid gap-2 d-md-block" style="float: right">
                     <button type="button" class="btn btn-outline-primary mx-2 px-3" @click="limpiar">Limpiar</button>
                     <button id="searchButton" type="button" class="btn btn-primary mx-2 px-3" @click="buscarContabilidades">Buscar</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <template v-if="showResultDatatable">
         <div class="datatable-results-title">Resultados</div>
         <div class="card card-frame mt-1 mb-5 h-auto w-100">
            <div id="cardDatatable" class="card-body h-auto">
               <ResultDatatableCampana
                  ref="resultDatatableCampana"
                  :idProceso="idProceso"
                  :idProcesoElectoral="idProcesoElectoral"
                  :idProcesoGeneral="idProcesoGeneral"
                  :ambito="ambito"
                  :idEstado="idEstado"
                  :idMunicipio="idMunicipio"
                  :idSujetoObligado="idSujetoObligado"
                  :idTipoCandidatura="idTipoCandidatura"
                  :idDistrito="idDistrito"
                  :secondary="secondary"
                  :showResult="showResult"
               />
            </div>
         </div>
      </template>
      <template v-else-if="showResultDatatableOrdinario">
         <div class="datatable-results-title">Resultados</div>
         <div class="card card-frame mt-1 mb-5 h-auto w-100">
            <div id="cardDatatable" class="card-body h-auto">
               <ResultDatatableOrdinario
                  ref="resultDatatableOrdinario"
                  :idOrganizacion="idOrganizacion"
                  :ambito="ambitoOrdinario"
                  :idEstado="idEstadoOrdinario"
                  :idSujetoObligado="idSujetoObligadoOrdinario"
                  :secondary="secondary"
                  :showResult="showResult"
               />
            </div>
         </div>
      </template>
   </div>
   <template v-if="resultMode">
      <div class="container px-0">
         <PrimeButton icon="pi pi-arrow-left" class="p-button-text p-button-plain px-0" label="Regresar" @click="showSearch" />
      </div>
      <ResultCardCampana
         ref="resultCardCampana"
         :resultData="resultData"
         :descripcion="descripcion"
         :idProcesoGeneral="idProcesoGeneral"
         :secondary="secondary"
         :addAjax="addAjax"
         :removeAjax="removeAjax"
         :load500Error="load500Error"
      ></ResultCardCampana>
   </template>
   <template v-if="resultModeOrdinario">
      <div class="container px-0">
         <PrimeButton icon="pi pi-arrow-left" class="p-button-text p-button-plain px-0" label="Regresar" @click="showSearch" />
      </div>
      <ResultCardOrdinario
         ref="resultCardOrdinario"
         :idProcesoGeneral="idProcesoGeneralOrdinario"
         :secondary="secondary"
         :resultData="resultData"
         :addAjax="addAjax"
         :removeAjax="removeAjax"
         :load500Error="load500Error"
      ></ResultCardOrdinario>
   </template>
   <PrimeDialog
      header="Proceso o ejercicio"
      v-model:visible="processDialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
   >
      <template #header>
         <span class="consulta-process-dialog-header w-100">Proceso o Ejercicio</span>
      </template>
      <FilterProcessDialog />
   </PrimeDialog>
</template>

<script setup>
import { ref, onMounted } from "vue";
import FilterCardCampana from "./FilterCardCampana.vue";
import FilterCardOrdinario from "./FilterCardOrdinario.vue";
import FilterProcessDialog from "./FilterProcessDialog.vue";
import FiltersDataService from "@/service/FiltersDataService";
import FiltersService from "@/service/FiltersService";
import ResultDatatableCampana from "@/components/ResultDatatableCampana.vue";
import ResultDatatableOrdinario from "@/components/ResultDatatableOrdinario.vue";
import ResultCardCampana from "@/components/ResultCardCampana.vue";
import ResultCardOrdinario from "./ResultCardOrdinario.vue";
import AppConfig from "@/conf/global";
import { useRouter } from "vue-router";
//import cookie from "cookie";

const resultMode = ref();
const resultModeOrdinario = ref();
const showResultDatatable = ref(false);
const showResultDatatableOrdinario = ref(false);
const ajaxRunningCount = ref(0);

let idProceso = ref(2);
let idProcesoElectoral = ref(1);
let idProcesoGeneral = ref(0);
let idProcesoGeneralOrdinario = ref(0);

let ambito = ref(null);
let idEstado = ref(0);
let idMunicipio = ref(null);

let ambitoOrdinario = ref(null);
let idEstadoOrdinario = ref(0);
let idOrganizacion = ref(null);
let idSujetoObligadoOrdinario = ref(null);

let descripcion = ref(null);

let btnActive = ref("active");
let btnInactive = ref("inactive");
let btnHover = ref("hover");
let btnCampain = ref(FiltersDataService.getBtnCampain());
let btnPrecampain = ref(FiltersDataService.getBtnPrecampain());
let btnOrdinary = ref(FiltersDataService.getBtnOrdinary());
let blockedDocument = ref(true);

let idSujetoObligado = ref(null);
let idTipoCandidatura = ref(null);
let idDistrito = ref(null);

const filterCardCampana = ref();

const resultDatatableCampana = ref();
const resultDatatableOrdinario = ref();
const resultCardCampana = ref();
const resultCardOrdinario = ref();
const resultData = ref();
const processDialog = ref(false);

let secondary = ref(false);

//const campanaInformes = ref([]);

const router = useRouter();

onMounted(() => {
   //console.log(cookie.parse(document.cookie));
   //console.log(csrf_token());
   checkBackend();
});

const checkBackend = () => {
   FiltersDataService.getInfo(secondary.value)
      .then((res) => {
         console.log(res.data.message);
      })
      .catch((err) => {
         console.error("Backend " + (secondary.value ? "Secundario" : "Primario") + " no alcanzado");
         if (!secondary.value) {
            secondary.value = true;
            checkBackend();
         } else {
            loadBackError(err);
         }
      })
      .finally(init());
};

const init = () => {
   if (idProceso.value == 3) {
      btnCampaniaMouseClick();
   } else if (idProceso.value == 2) {
      btnPrecampaniaMouseClick();
   } else if (idProceso.value == 1) {
      btnOrdinarioMouseClick();
   }
   //disableSearchButton();
};

const loadBackError = (err) => {
   router.push({ name: "LoadBackError", replace: true, params: { error: err } });
   //router.push({ name: "Error500", replace: true, params: { error: err } });
   resetAjax();
};

const load500Error = (err) => {
   router.push({ name: "Error500", replace: true, params: { error: err } });
   resetAjax();
};

const limpiar = () => {
   router.push("/limpiar");
};

const checkAjax = () => {
   if (ajaxRunningCount.value == 0) blockedDocument.value = false;
   else blockedDocument.value = true;
};

const addAjax = () => {
   ajaxRunningCount.value = ajaxRunningCount.value + 1;
   checkAjax();
};

const removeAjax = () => {
   ajaxRunningCount.value = ajaxRunningCount.value - 1;
   checkAjax();
};

const resetAjax = () => {
   ajaxRunningCount.value = 0;
   checkAjax();
};

const showResult = (data) => {
   //console.log("show result idProcesoGeneral: " + idProcesoGeneral.value);
   resultData.value = data;
   if (idProceso.value == 1) {
      resultModeOrdinario.value = AppConfig.resultMode;
      resultMode.value = null;
   } else {
      resultMode.value = AppConfig.resultMode;
      resultModeOrdinario.value = null;
   }
   FiltersService.hideById("#filters");
};

const showSearch = () => {
   //searchMode.value = AppConfig.searchMode;
   resultMode.value = null;
   resultModeOrdinario.value = null;
   FiltersService.showById("#filters");
   //FiltersService.scrollToId("#cardDatatable");
};

const setIdProceso = (parIdProceso) => {
   idProceso.value = parIdProceso;
   if (idProceso.value == btnCampain.value.idProceso) {
      btnPrecampain.value.state = btnInactive.value;
      btnOrdinary.value.state = btnInactive.value;
      btnPrecampaniaMouseLeave();
      btnOrdinarioMouseLeave();
      filterCardCampana.value.changeProcess(parIdProceso);
   } else if (idProceso.value == btnPrecampain.value.idProceso) {
      btnCampain.value.state = btnInactive.value;
      btnOrdinary.value.state = btnInactive.value;
      btnCampaniaMouseLeave();
      btnOrdinarioMouseLeave();
      filterCardCampana.value.changeProcess(parIdProceso);
   } else if (idProceso.value == btnOrdinary.value.idProceso) {
      btnCampain.value.state = btnInactive.value;
      btnPrecampain.value.state = btnInactive.value;
      btnCampaniaMouseLeave();
      btnPrecampaniaMouseLeave();
   }
};

const sincronizar = (
   parIdProcesoElectoral,
   parIdProcesoGeneral,
   parAmbito,
   parIdEstado,
   parIdMunicipio,
   parIdSujetoObligado,
   parIdTipoCandidatura,
   parIdDistrito,
   parDescripcion,
   parshowResultDatatable
) => {
   //console.log("parDescripcion:" + parDescripcion);
   idProcesoElectoral.value = parIdProcesoElectoral;
   idProcesoGeneral.value = parIdProcesoGeneral;
   ambito.value = parAmbito;
   idEstado.value = parIdEstado;
   idMunicipio.value = parIdMunicipio;
   idSujetoObligado.value = parIdSujetoObligado;
   idTipoCandidatura.value = parIdTipoCandidatura;
   idDistrito.value = parIdDistrito;
   descripcion.value = parDescripcion;
   showResultDatatable.value=parshowResultDatatable 
   //console.log("descripcion.value:" + descripcion.value);
};

const sincronizarOrdinario = (parIdProcesoGeneral, parAmbito, parIdOrganizacion, parIdEstado, parIdSujetoObligado) => {
   idProcesoGeneralOrdinario.value = parIdProcesoGeneral;
   ambitoOrdinario.value = parAmbito;
   idOrganizacion.value = parIdOrganizacion;
   idEstadoOrdinario.value = parIdEstado;
   idSujetoObligadoOrdinario.value = parIdSujetoObligado;
};

const buscarContabilidades = () => {
   if (idProceso.value > 1) {
      showResultDatatableOrdinario.value = false;
      if (showResultDatatable.value) resultDatatableCampana.value.loadLazyData();
      showResultDatatable.value = true;
   } else if (idProceso.value == 1) {
      showResultDatatable.value = false;
      if (showResultDatatableOrdinario.value) resultDatatableOrdinario.value.loadLazyData();
      showResultDatatableOrdinario.value = true;
   } else {
      showResultDatatable.value = false;
      showResultDatatableOrdinario.value = false;
   }
};
/*const btnCampaniaMouseEnter = () => {
   if (btnCampain.value.state != btnActive.value) {
      btnCampain.value.state = btnHover.value;
      FiltersService.hoverButton("#btn-filter-card-form-campania", btnCampain.value.srcHover);
   }
};*/

const btnCampaniaMouseLeave = () => {
   if (btnCampain.value.state != btnActive.value) {
      btnCampain.value.state = btnInactive.value;
      FiltersService.unHoverButton("#btn-filter-card-form-campania", btnCampain.value.srcInactive);
   }
};

const btnCampaniaMouseClick = () => {
   //btnCampain.value.state = btnActive.value;
   //FiltersService.activeButton("#btn-filter-card-form-campania", btnCampain.value.srcActive);
   //showResultDatatableOrdinario.value = false;
   //setIdProceso(btnCampain.value.idProceso);
};

const btnPrecampaniaMouseEnter = () => {
   if (btnPrecampain.value.state != btnActive.value) {
      btnPrecampain.value.state = btnHover.value;
      FiltersService.hoverButton("#btn-filter-card-form-precampania", btnPrecampain.value.srcHover);
   }
};

const btnPrecampaniaMouseLeave = () => {
   if (btnPrecampain.value.state != btnActive.value) {
      btnPrecampain.value.state = btnInactive.value;
      FiltersService.unHoverButton("#btn-filter-card-form-precampania", btnPrecampain.value.srcInactive);
   }
};

const btnPrecampaniaMouseClick = () => {
   btnPrecampain.value.state = btnActive.value;
   FiltersService.activeButton("#btn-filter-card-form-precampania", btnPrecampain.value.srcActive);
   showResultDatatableOrdinario.value = false;
   setIdProceso(btnPrecampain.value.idProceso);
};
/*
const btnOrdinarioMouseEnter = () => {
   if (btnOrdinary.value.state != btnActive.value) {
      btnOrdinary.value.state = btnHover.value;
      FiltersService.hoverButton("#btn-filter-card-form-ordinario", btnOrdinary.value.srcHover);
   }
};*/

const btnOrdinarioMouseLeave = () => {
   if (btnOrdinary.value.state != btnActive.value) {
      btnOrdinary.value.state = btnInactive.value;
      FiltersService.unHoverButton("#btn-filter-card-form-ordinario", btnOrdinary.value.srcInactive);
   }
};

const btnOrdinarioMouseClick = () => {
  // btnOrdinary.value.state = btnActive.value;
   //FiltersService.activeButton("#btn-filter-card-form-ordinario", btnOrdinary.value.srcActive);
   //showResultDatatable.value = false;
   //setIdProceso(btnOrdinary.value.idProceso);
};

const openProcessDialog = () => {
   processDialog.value = true;
};
</script>
